class DeliveryEstimation extends HTMLElement {
  constructor() {
    super();
    this.minDateElement = null;
    this.maxDateElement = null;
    this.config = {
      locale: 'fr',
      minDays: 3,
      maxDays: 5,
      noSaturday: false,
      noSunday: false,
      dateFormat: 'in_letters',
      showWeekday: true,
      cutoffHour: null,
    };
  }

  connectedCallback() {
    this.minDateElement = this.querySelector('[data-ref="min-date"]');
    this.maxDateElement = this.querySelector('[data-ref="max-date"]');
    this.#loadConfiguration();
    this.#calculateAndDisplayDates();
  }

  #loadConfiguration() {
    this.config.locale = this.dataset.locale || 'fr';
    this.config.minDays = parseInt(this.dataset.minDays) || 3;
    this.config.maxDays = parseInt(this.dataset.maxDays) || 5;
    this.config.noSaturday = this.dataset.noSaturday === 'true';
    this.config.noSunday = this.dataset.noSunday === 'true';
    this.config.dateFormat = this.dataset.dateFormat || 'in_letters';
    this.config.showWeekday = this.dataset.showWeekday === 'true';
    const cutoffHour = this.dataset.cutoffHour;
    if (cutoffHour && cutoffHour !== '') {
      this.config.cutoffHour = parseInt(cutoffHour);
    }
  }

  #calculateAndDisplayDates() {
    const minDate = this.#calculateDeliveryDate(this.config.minDays);
    const maxDate = this.#calculateDeliveryDate(this.config.maxDays);
    const sameMonth = minDate.getMonth() === maxDate.getMonth() && minDate.getFullYear() === maxDate.getFullYear();

    if (this.minDateElement) {
      if (sameMonth && this.config.dateFormat !== 'numbers') {
        this.minDateElement.textContent = minDate.getDate();
      } else {
        this.minDateElement.textContent = this.#formatDate(minDate);
      }
    }

    if (this.maxDateElement) {
      this.maxDateElement.textContent = this.#formatDate(maxDate);
    }
  }

  #calculateDeliveryDate(daysToAdd) {
    const now = new Date();
    let startDate = new Date();
    if (this.config.cutoffHour !== null) {
      const currentHour = now.getHours();
      if (currentHour >= this.config.cutoffHour) {
        startDate.setDate(startDate.getDate() + 1);
      }
    }
    let businessDaysAdded = 0;
    let currentDate = new Date(startDate);
    while (businessDaysAdded < daysToAdd) {
      currentDate.setDate(currentDate.getDate() + 1);
      const dayOfWeek = currentDate.getDay();
      const isSaturday = dayOfWeek === 6;
      const isSunday = dayOfWeek === 0;
      const isBusinessDay = !((isSaturday && this.config.noSaturday) || (isSunday && this.config.noSunday));
      if (isBusinessDay) {
        businessDaysAdded++;
      }
    }
    while (this.#isNonDeliveryDay(currentDate)) {
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return currentDate;
  }

  #isNonDeliveryDay(date) {
    const dayOfWeek = date.getDay();
    const isSaturday = dayOfWeek === 6;
    const isSunday = dayOfWeek === 0;
    return (isSaturday && this.config.noSaturday) || (isSunday && this.config.noSunday);
  }

  #formatDate(date) {
    const options = {};
    if (this.config.dateFormat === 'numbers') {
      options.day = 'numeric';
      options.month = 'numeric';
    } else {
      options.day = 'numeric';
      options.month = 'short';
    }
    if (this.config.showWeekday) {
      options.weekday = 'long';
    }
    const formatter = new Intl.DateTimeFormat(this.config.locale, options);
    let formattedDate = formatter.format(date);
    formattedDate = this.#capitalizeFirstLetter(formattedDate);
    return formattedDate;
  }

  #capitalizeFirstLetter(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}

if (!customElements.get('delivery-estimation')) {
  customElements.define('delivery-estimation', DeliveryEstimation);
}
